import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage, Link } from "gatsby-plugin-intl";
import { Container, Menu, Segment, Sidebar } from "semantic-ui-react";
import HomepageHeading from "./HomepageHeading";
import NavBar from "./NavBar";

class MobileContainer extends PureComponent {
  static propTypes = {
    landing: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
  };

  static childContextTypes = {
    isMobile: PropTypes.bool,
  };

  state = {
    sidebarOpened: false,
  };

  getChildContext() {
    return {
      isMobile: true,
    };
  }

  handlePusherClick = () => {
    const { sidebarOpened } = this.state;

    if (sidebarOpened) this.setState({ sidebarOpened: false });
  };

  handleToggle = () => {
    const { sidebarOpened } = this.state;
    this.setState({ sidebarOpened: !sidebarOpened });
  };

  render() {
    const { children, landing, intl } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <div>
        <Sidebar.Pushable>
          <Sidebar
            as={Menu}
            animation="uncover"
            inverted
            vertical
            visible={sidebarOpened}
          >
            <Menu.Item name="index" as={Link} to="/">
              <FormattedMessage id="nav_home" />
            </Menu.Item>
            {intl.locale === "ko" && (
              <Menu.Item as={Link} to="/features">
                <FormattedMessage id="nav_features" />
              </Menu.Item>
            )}
            <Menu.Item as={Link} to="/download">
              <FormattedMessage id="nav_download" />
            </Menu.Item>
            {intl.locale !== "ko" && (
              <Menu.Item as={Link} to="/buy">
                <FormattedMessage id="nav_buy" />
              </Menu.Item>
            )}
            <Menu.Item as={Link} to="/contact">
              <FormattedMessage id="nav_contact" />
            </Menu.Item>
            {intl.locale !== "ko" && (
              <Menu.Item as={Link} to="/partners">
                <FormattedMessage id="nav_partners" />
              </Menu.Item>
            )}
          </Sidebar>

          <Sidebar.Pusher
            dimmed={sidebarOpened}
            onClick={this.handlePusherClick}
            style={{ minHeight: "100vh" }}
          >
            {landing ? (
              <Segment
                inverted
                textAlign="center"
                style={{
                  minHeight: 550,
                  padding: "1em 0em",
                  backgroundColor: "#015a9e",
                }}
                vertical
              >
                <Container>
                  <NavBar
                    fixed={false}
                    toggle
                    onToggleClick={this.handleToggle}
                  />
                </Container>
                <HomepageHeading />
              </Segment>
            ) : (
              <Segment
                style={{
                  padding: "1em 0em",
                }}
                vertical
              >
                <NavBar fixed toggle onToggleClick={this.handleToggle} />
              </Segment>
            )}
            {children}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default injectIntl(MobileContainer);
